import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
// import { TextYellowLightColor } from '../../../components/Text'
import { ButtonYellowLight, ButtonYellowConfirmed } from '../../../components/Button'
import Row from '../../../components/Row'

const Infowapper = styled.div`
  max-width: 1440px;
  margin: auto;
  margin-top: 53px;
  box-sizing: border-box;
  padding: 0px 25px;
`
const InfoTitle = styled(Row)`
  
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 120%;
  color: ${({ theme }) => theme.bsText41};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
  `}
`

const InfoIntro = styled.div`
  
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 130%;
  color: ${({ theme }) => theme.bsText42};
  margin-top: 10px;
`

const ButtonRow = styled(Row)`
  margin-top: 40px;
`

const ExploreButton = styled(ButtonYellowConfirmed)`
  width: 172px;
  height: 40px;
  align-items: center;
  display: flex;
  font-family: 'Roboto-Medium';
`

const CreateButton = styled(ButtonYellowLight)`
  width: 172px;
  height: 40px;
  align-items: center;
  display: flex;
  margin-left: 16px;
  color: #FF7A00;
  font-family: 'Roboto-Medium';
`

export default function BakeryInfo() {
  const history = useHistory();

  const goCreate = () => {
    history.push(`/mint-newArtworks/111,3`)
  }

  const goExplore = () => {
    history.push(`/explore`)
  }
  
  return (
    <Infowapper>
      <InfoTitle>
        Trade your favourite NFTs Now!
      </InfoTitle>
      <InfoIntro>On BSC’s first & largest marketplace</InfoIntro>
      <ButtonRow>
        <ExploreButton onClick={() => goExplore()}>Explore</ExploreButton>
        <CreateButton onClick={() => goCreate()}>Create</CreateButton>
      </ButtonRow>
    </Infowapper>
  )
}

